import { render } from "./CompetitionTable.vue?vue&type=template&id=e6d17ffc&scoped=true"
import script from "./CompetitionTable.vue?vue&type=script&lang=js"
export * from "./CompetitionTable.vue?vue&type=script&lang=js"

import "./CompetitionTable.vue?vue&type=style&index=0&id=e6d17ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d17ffc"]])

export default __exports__